import React from "react";
import { Props } from "./types";

function useActivityWatcher(
  ref:
    | React.RefObject<HTMLDivElement | null>
    | React.RefObject<HTMLDivElement | null>[],
  events: { focus?: Function; blur?: Function },
) {
  React.useEffect(() => {
    const refs = Array.isArray(ref) ? ref : [ref];

    function closeSelect(e: MouseEvent) {
      e.stopPropagation();
      const selectElContainsTarget = refs.reduce<boolean>(
        (contains, ref) =>
          contains || (!!ref.current && ref.current.contains(e.target as Node)),
        false,
      );

      !selectElContainsTarget
        ? events.blur && events.blur()
        : events.focus && events.focus();
    }

    document.addEventListener("click", closeSelect);

    return () => {
      document.removeEventListener("click", closeSelect);
    };
  }, [events.focus, events.blur]);
}

function ActivityWatcher(props: Props) {
  const ref = React.useRef<HTMLDivElement>(null);

  useActivityWatcher(ref, props);

  return (
    <div ref={ref} className={props.className} style={props.style}>
      {props.children}
    </div>
  );
}

ActivityWatcher.useActivityWatcher = useActivityWatcher;

export { ActivityWatcher };
